import { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getOnePolicyItem, getOnePageItem } from "../api/api";
import { ImagesEntity, IInnerPage, IInnerPolicy } from "../types/inner_page";
import Loader from "react-loader-spinner";
import { GLOBAL_MEDIA_QUERIES, primaryColors, secondaryColors } from "../constatnts";
import { useTranslation } from "react-i18next";
import {useMedia} from "react-media"
import { IMedia } from "../types/types";
import InnerPageLayout from "../Components/Layout/InnerPageLayout";
import { useParams } from "react-router-dom";
import Caac from "../Components/Chart/caac.js";



interface IProps {
  id?: string;
}
const PolicyPage = (props: IProps) => {
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  let { id } = useParams(); 

  const {  i18n } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    `innerPolicyData-${id}`,
    () => getOnePolicyItem({ id: id || "1", language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language]);

  if (isLoading)
    return (
      <InnerPageLayout>
        <LoaderContainer>
          <Loader
            type="Puff"
            color="#ffffff"
            height={70}
            width={70}
            timeout={3000} //3 secs
          />
        </LoaderContainer>
      </InnerPageLayout>
    );

  if (error)
    return (
      <InnerPageLayout>
        <div></div>
      </InnerPageLayout>
    );

  let pageItem: IInnerPolicy = data["data"];
  const documentsArray = pageItem?.documents
  ? Object.keys(pageItem.documents)
      .filter((key) => key.startsWith("text"))
      .map((key) => {
        const index = key.replace("text", "");
        return {
          title: pageItem.documents[`text${index}`],
          pdf: pageItem.documents[`pdf${index}`],
        };
      })
  : [];

  return (
    <InnerPageLayout>
      <>
        {/* <Container  {...matches}>
          <Content>
            <h4 className="shape-round mb-lg-5 pb-5">{pageItem.title}</h4>


            <ReactMarkdown>{pageItem.content}</ReactMarkdown> <Spacer />
          </Content>
          <ImagesContainer>
            {pageItem.images.map((image: ImagesEntity) => (
              <Image src={`${process.env.REACT_APP_CMS}${image?.url}`}  {...matches} />
            ))}
          </ImagesContainer>
        </Container> */}

        <br />

        <br />

        <Container  {...matches}>
          <Content>
            {/* <h4 className="shape-round mb-lg-5 pb-5">السياسات والإجراءات</h4> */}

            <div dir="rtl">
              <div dir="rtl">
                <table>
                  <tbody>
                    {documentsArray.map((doc, index) => (
                      <tr key={index}>
                        <th className="background-color">
                          <h5>{doc.title}</h5>
                        </th>

                        <td className="padding">
                          <a
                            className="shape-rounded-view"
                            href={doc.pdf}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            للاطلاع والتحميل
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            {/* <table >
              <tr>
                <th className="background-color"><h5>{pageItem.documents.text1}</h5></th>
                <th className="padding "><a></a></th>
                <th className="background-color"><h5>{pageItem.documents.text2}</h5></th>
              </tr>
              <tr>
              <td> */}
                  {/* <h6 className="shape-view ">{pageItem.documents.pdf1}</h6> */}
                  {/* <a className="shape-rounded-view " href={`${pageItem.documents.pdf1}`} download >
                    <a className="background-color " href={`${pageItem.documents.pdf1}`} download >للاطلاع والتحميل</a>
                  </a> */}
                  {/* <a className="shape-download " href={`${pageItem.documents.pdf1}`} download >لتحميل الملف</a> */}
                {/* <Image src={`${pageItem.documents.pdf1}`}  {...matches} /> */}
                {/* </td>
                <td> */}
                  {/* <h6 className="shape-view ">{pageItem.documents.pdf1}</h6> */}
                  {/* <a >     </a>
                  <a >     </a> */}
                {/* <Image src={`${pageItem.documents.pdf1}`}  {...matches} /> */}
                {/* </td>
                <td>
                <a className="shape-rounded-view " href={`${pageItem.documents.pdf2}`} download >
                  <a className="background-color " href={`${pageItem.documents.pdf2}`} download >للاطلاع والتحميل</a>
                </a> */}
                  {/* <a className="shape-download " href={`${pageItem.documents.pdf2}`} download="download" >لتحميل الملف</a> */}
                {/* <Image src={`${pageItem.documents.pdf2}`}  {...matches} /> */}
                  {/* <a href={`${pageItem.documents.pdf1}`} download>للإطلاع على الملف</a> */}
                  {/* <a href={`${pageItem.documents.pdf2}`} download>لتحميل الملف</a> */}
                  {/* <a href={`${pageItem.documents.pdf2}`} download rel="لتحميل الملف" target="_blank">
                  للإطلاع على الملف
                  </a> */}
                {/* </td>
              </tr>
            </table> */}
            {/* <h4 className="shape-round mb-lg-5 pb-5">{pageItem.documents.text1}</h4>
            <h4 className="shape-round mb-lg-5 pb-5">{pageItem.documents.text2}</h4> */}

              {/* <Caac ds={pageItem.documents} /> */}
              {/* <Image src={`${process.env.REACT_APP_CMS}${image?.url}`}  {...matches} /> */}
            </div>
          </Content>
        </Container>



      </>
    </InnerPageLayout>
  );
};


const TitleImage = styled.img`
  position: absolute;
  width: 80px;
  top: 0;
  z-index: -1;
  right: -10px;
`;

const Container = styled.div<IMedia>`
  padding: ${(props) => (props.large ? "30px 70px" : "10px 10px")};
  flex-direction : ${(props) => (props.large ? "row" : "column-reverse")};
  display: flex;
  position: relative;
`;

const Content = styled.div`
  padding: 10px 30px;
  line-height: 1.5em;
  position: relative;
  flex:1;
  color: ${primaryColors[3]};
  margin:10px;
`;

const ImagesContainer = styled.div`


`;
const Title = styled.h1`
  color: ${primaryColors[0]};
`;
const SubTitle = styled.h4`
  color: ${secondaryColors[0]};
`;

const Spacer = styled.div`
  height: 30px;
  width: 30px;
`;

const Image = styled.img<IMedia>`
  width: ${(props) => (props.large ? "45vw" : "100vw")};
  box-shadow: 20px 19px 0 0 rgb(189 189 189 / 50%);
  object-fit: contain;
    height: 500px;
`;
const LoaderContainer = styled.div`
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default PolicyPage;
